export const getChangedFields = (vals: Record<any, any>, initialValues: Record<any, any>) => {
  const changedValues: Record<any, any> = {};

  Object.keys(vals).forEach((key) => {
    if (vals[key] !== initialValues[key]) {
      changedValues[key] = vals[key];
    }
  });

  return changedValues;
};

export const checkHasChangedFields = (vals: Record<any, any>, initialValues: Record<any, any>) =>
  Object.keys(vals).some(key => vals[key] !== initialValues[key]);
